module.exports = __webpack_public_path__ + "static/10-4b1979894baf5e5f5770dc5c06f446f7.jpg";